"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLibraryLoadCheck = void 0;
const core_1 = require("../../core");
const withLibraryLoadCheck = (library) => {
    const noProxyFns = ['load', 'isLoaded'];
    return new Proxy(library, {
        get: (target, prop) => {
            if (prop in target && typeof target[prop] === 'function' && noProxyFns.indexOf(prop.toString()) < 0) {
                if (!target.isLoaded()) {
                    core_1.Log.error(`${target.name}: trying to access to ${prop.toString()} function but library is not loaded`);
                }
            }
            return target[prop].bind(target);
        },
    });
};
exports.withLibraryLoadCheck = withLibraryLoadCheck;
//# sourceMappingURL=helper.js.map